import React from "react"
import SEO from "../components/SEO"
import HeThongCuaHangPage from "../features/he-thong-cua-hang"
import { WEBSITE } from "../constants"

const HeThongCuaHang: React.FC = () => {
  return (
    <>
      <SEO
        title={`Trang chủ | ${WEBSITE.TITLE}`}
        description={WEBSITE.DESCRIPTION}
        keywords={WEBSITE.KEYWORDS}
      />
      <HeThongCuaHangPage />
    </>
  )
}

export default HeThongCuaHang
